import { ChevronRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const highlights = [
  { value: '05+', label: 'Year of experience in the aviation industry' },
  { value: '135+', label: 'Countries present' },
  { value: '2K+', label: 'Satisfied Customers' },
];

const certifications = [
  { label: 'International Aviation Standards', value: 95 },
  { label: 'Customer Satisfaction', value: 90 },
  { label: 'Professional Team', value: 98 },
];

function WhyChooseUsSection() {
  return (
    <section className="relative py-20 md:py-24 bg-gradient-to-br from-black via-[#0b1f33] to-[#1a3c55] text-white overflow-hidden">
      <div className="hero-pattern absolute inset-0" />
      <div className="container relative mx-auto px-4">
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2 mb-10 md:mb-0 animate-fadeInLeft">
            <p className="eyebrow mb-3">Why Moreflex</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">
              Why you Should choose
              <br />
              Moreflex Aviation Support Services
            </h2>
            <p className="mb-8 text-white/70">
              We go beyond the ordinary to provide a stress-free and luxurious
              airport experience. With our exceptional expertise in premium
              lounge access and reliable transportation, we make a committed
              to ensuring your journey is smooth, efficient, and enjoyable.
            </p>

            <div className="space-y-6">
              {highlights.map((item) => (
                <div key={item.label} className="flex items-center">
                  <div className="bg-white/10 w-12 h-12 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-lg font-heading font-bold text-[#73BDF2]">{item.value}</span>
                  </div>
                  <p className="text-white/85">{item.label}</p>
                </div>
              ))}
            </div>

            <Link to="/contact">
            <button className="btn-primary mt-10">
              Get Started <ChevronRight size={18} />
            </button>
            </Link>
          </div>

          <div className="md:w-1/2 md:pl-12 animate-fadeInRight">
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl backdrop-blur-sm">
              <div className="flex items-center gap-2 mb-6">
                <ShieldCheck size={20} className="text-[#73BDF2]" />
                <h3 className="text-xl font-heading font-bold">License & Certifies</h3>
              </div>
              <div className="space-y-5">
                {certifications.map((cert) => (
                  <div key={cert.label}>
                    <div className="w-full bg-white/10 h-1.5 rounded-full overflow-hidden">
                      <div className="bg-[#73BDF2] h-1.5 rounded-full" style={{ width: `${cert.value}%` }}></div>
                    </div>
                    <div className="flex justify-between mt-2 text-sm text-white/80">
                      <span>{cert.label}</span>
                      <span className="font-semibold">{cert.value}%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUsSection;
